import type { PipeTransform } from '@angular/core'
import { DOCUMENT, Pipe, inject } from '@angular/core'

@Pipe({ name: 'htmlToPlaintext' })
export class HtmlToPlaintextPipe implements PipeTransform {
  private document = inject<Document>(DOCUMENT)

  constructor() {
    const document = this.document

    this.document = document
  }

  /** Flattens a html string to plain text. Assumes the content is safe */
  transform(value: string): string {
    if (!value) {
      return ''
    }

    const tempDiv = this.document.createElement('div')
    tempDiv.innerHTML = value
    return tempDiv.innerText || tempDiv.textContent || ''
  }
}
